import { render, staticRenderFns } from "./title-new.vue?vue&type=template&id=295b8860&scoped=true"
import script from "./title-new.vue?vue&type=script&lang=js"
export * from "./title-new.vue?vue&type=script&lang=js"
import style0 from "./title-new.vue?vue&type=style&index=0&id=295b8860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b8860",
  null
  
)

export default component.exports